import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { hashes } from '../../constants/paths';
import { CustomerProductsContainer } from '../../modules/CustomerProducts/containers/customer-products-container';
import HealthCheckContainer from '../../modules/HealthCheck/containers/health-check-container';
import { AddressHistoryContainer } from '../../modules/AddressHistory/containers/address-history-container';
import FollowUpFormsContainer from '../../modules/FollowUpForms/FollowUpFormsContainer';
import { UnknownHash } from './unknown-hash';
import { NotHome } from '../../modules/Workorder/components/not-home/not-home';
import { WorkOrderHistoryContainer } from '../../modules/WorkOrderHistory/containers/work-order-history-container';
import styled from 'styled-components';
const SlideInPortal = styled.div `
  position: fixed;
  top: 0;
  z-index: 3;
  height: 100%;
  width: 100%;
  right: 0;

  &.slide-enter {
    right: -100vw;
  }

  &.slide-enter-active {
    right: 0;
    transition: right 450ms ease-in;
  }

  &.slide-exit {
    right: 0;
  }

  &.slide-exit-active {
    right: -100vw;
    transition: right 450ms ease-out;
  }

  &.slide-exit-done {
    display: none;
  }
`;
export const SlideInPagePortal = ({ hash }) => {
    // keep selected hash in state so content does not disappear on slide out
    const [selectedHash, setSelectedHash] = useState(hash);
    useEffect(() => {
        // keep previous hash so it does not disappear on slide out
        if (hash !== selectedHash && hash) {
            setSelectedHash(hash);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hash]);
    // To display containers correctly, wrap container in CSSTransition content
    const containers = [
        { hash: hashes.customerProducts, container: _jsx(CustomerProductsContainer, {}) },
        { hash: hashes.addressHistory, container: _jsx(AddressHistoryContainer, {}) },
        { hash: hashes.workOrderHistory, container: _jsx(WorkOrderHistoryContainer, {}) },
        { hash: hashes.healthCheck, container: _jsx(HealthCheckContainer, {}) },
        { hash: hashes.followUp, container: _jsx(FollowUpFormsContainer, {}) },
        { hash: hashes.notHome, container: _jsx(NotHome, {}) },
    ];
    const selectedContainer = containers.find((container) => container.hash === selectedHash);
    const portalTarget = document.getElementById('slide-in-page');
    if (!portalTarget) {
        // In case the target element is missing, render nothing to avoid runtime errors
        return null;
    }
    return ReactDOM.createPortal(_jsx(CSSTransition, { in: !!hash, timeout: 450, classNames: "slide", className: "slide_in_portal", mountOnEnter: true, unmountOnExit: true, children: _jsx(SlideInPortal, { children: selectedContainer
                ? selectedContainer.container
                : _jsx(UnknownHash, {}) }) }), portalTarget);
};
